import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import Editor from "@monaco-editor/react";

export default function CodeEditorViewer(props, { onChange, languaje, code }) {
  const { languageCode, codeValue, fromEdit, } = props;
  const [value, setValue] = useState(code || "");
  const [languajeSelect, setLanguajeSelect] = useState(languageCode);

  useEffect(() => {
    switch (languajeSelect) {
      case "python":
        setValue("# Write code for python");
        break;
      case "perl":
        setValue("#!/usr/bin/perl");
        break;
      case "ruby":
        setValue("# Copyright (c) Microsoft. All rights reserved. Ruby");
        break;
      case "powershell":
        setValue("#When the XenCenter node powershell");
        break;
      case "bat":
        setValue("rem *******Begin Comment**************");
        break;
      case "shell":
        setValue("# Simple line count example, using bash");
        break;

      default:
        setValue("");
        break;
    }
  }, [languajeSelect]);

  const handleEditorChange = (value) => {
    props.handleText(value);
    setValue(value);
  };
  const handleChange = (event) => {
    setLanguajeSelect(event.target.value);
    props.HandleLanguajeSelect(event.target.value);
  };
  return (
    <>
      <Box sx={{ minWidth: 300, marginBottom: 2, marginTop: "20px" }}>
        <FormControl fullWidth>
          <InputLabel>Select Code Editor Language*</InputLabel>
          <Select disabled={fromEdit} value={languajeSelect} onChange={handleChange}>
            <MenuItem value="python">Python</MenuItem>
            <MenuItem value="perl">Perl</MenuItem>
            <MenuItem value="ruby">Ruby</MenuItem>
            <MenuItem value="powershell">Powershell</MenuItem>
            <MenuItem value="bat">Batch</MenuItem>
            <MenuItem value="shell">Shell</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Editor
        height="50vh"
        width={`100%`}
        language={languajeSelect || "python"}
        value={fromEdit ? codeValue : value}
        theme="vs-dark"
        defaultValue="// some comment"
        onChange={handleEditorChange}
      />
    </>
  );
}
